<template>
    <div class="inlineBlock">
        <!-- 省级 -->
        <select class="selectbox areaSelect" v-model="value[0]" @change="onChangeProvince">
            <option value="">--请选择--</option>
            <option v-for="(provinceItem, index) in provinceList" :key="index" :value="provinceItem.name">
                {{provinceItem.name}}
            </option>
        </select>

        {{separator}}

        <!-- 市级 -->
        <select class="selectbox areaSelect" v-model="value[1]" @change="onChangeCity">
            <option value="">--请选择--</option>
            <option v-for="(cityItem, index) in cityList" :key="index" :value="cityItem.name">
                {{cityItem.name}}
            </option>
        </select>

        {{separator}}

        <!-- 区/镇/县 -->
        <select class="selectbox areaSelect" v-model="value[2]" @change="onChangeArea">
            <option value="">--请选择--</option>
            <option v-for="(areaItem, index) in areaList" :key="index" :value="areaItem.name">
                {{areaItem.name}}
            </option>
        </select>
    </div>
</template>

<script>

// data
import citiesData from '@data/cities_v2.json'

import arrayHelper from "@util/arrayHelper";

export default {
    name: "threeLevelAreaSelector",
    props : {
        value : {
            type : Array,
            default : () => {
                return ['', '', ''];
            }
        },
        separator : {
            type : String,
            default : '-'
        }
    },
    data() {
        return {
            provinceList : [],
            cityList : [],
            areaList : []
        }
    },
    methods : {

        updateOptions() {

            // get selected province
            let selectedProvince = arrayHelper.getItemByColumn(this.provinceList, 'name', this.value[0]);

            if (selectedProvince)
            {
                // update city list
                this.cityList = selectedProvince.childrens;

                // get selected city
                let selectedCity = arrayHelper.getItemByColumn(this.cityList, 'name', this.value[1]);

                if (selectedCity)
                {
                    // update area list
                    this.areaList = selectedCity.childrens;
                }
            }

        },
        onChangeProvince() {
            this.value[1] = this.value[2] = '';
            this.updateOptions();
            this.onChange();
        },
        onChangeCity() {
            this.value[2] = '';
            this.updateOptions();
            this.onChange();
        },
        onChangeArea() {
            this.onChange();
        },
        onChange() {
            this.$emit('input', this.value);
        }
    },
    updated() {
        this.updateOptions();
    },
    mounted() {

        // each province
        for (let provinceKey in citiesData)
        {
            let provinceItem = {
                name : provinceKey,
                childrens : []
            };

            // each city
            for (let cityKey in citiesData[provinceKey])
            {
                let cityItem = {
                    name : cityKey,
                    childrens : []
                };

                for (let areaKey = 0; areaKey < citiesData[provinceKey][cityKey].length; areaKey++)
                {
                    cityItem.childrens.push({
                        name : citiesData[provinceKey][cityKey][areaKey]
                    });
                }

                provinceItem.childrens.push(cityItem);
            }

            this.provinceList.push(provinceItem);
        }
    }
}
</script>

<style lang="scss" scoped>
.areaSelect {
    min-width: 63px;
    height: 28px;
    line-height: 28px;
    background: #FCF9F9;
    border: 1px solid #D9D9D9;
    outline: none;
    padding: 0 1em;

    border-radius: 4px;
    appearance: none; /* 去掉默认图标 */
    margin: 0 5px;
    text-align: center;
    font-weight: bold;
}
</style>
